import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_GET_DP_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  responseType: 'json',
});

const storedUser = localStorage.getItem("user");
const user = storedUser ? JSON.parse(storedUser) : null;

const authService = {
  user,
  async login(credential, callback) {
    try {
      const response = await api.post('/auth/google/callback', {
        id_token: credential
      });
      const { token, user } = response.data;

      localStorage.setItem('u_token', JSON.stringify(token));
      localStorage.setItem('user', JSON.stringify(user));
      callback(user)
    } catch (error) {
      console.error('LOGIN-Error:: ', error);
    }
  },
  logout(callback) {
    localStorage.removeItem('u_token');
    localStorage.removeItem('user');
    // setTimeout(callback, 100);
    callback();
  },
};

export { authService };
